<div class="main-panel" [ngStyle]="{'background-color':giftCards.imageBackgroundColorCode}">
  <div>
    <div class="row m-0 p-2" id="topSec">
      <div class="col-12">
        <alert class="alert-position"></alert>
      </div>
      <h2 class="col-12 p-3 back-btn-header" id="myUserLabel">
        <label class="login-back-btn" *ngIf="cardType=='Virtual Card' && cardCount>1" (click)="previousState()">
          <img src="../../assets/img/back.png">
        </label>
        <div class="log-out-menu c-pointer">
          <a (click)=logOut()>
            <label class="fa fa-power-off"></label>
          </a>
        </div>
      </h2>
      <div class="col-12 p-2" style="display: contents;">
        <div class="img-container">
          <div class="cardBg ml-auto mr-auto text-center" [ngStyle]="{'background-color':giftCards.imageBackgroundColorCode}">
            <div class="txnSec-spinner" *ngIf="cardImageLoaded!=true">
              <div class="txnSec-inner pl-0">
                <span class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </span>
              </div>
            </div>
            <img src="{{getGiftCardsImageUrl()}}" [ngClass]="{'card-image-visible' : cardImageLoaded}" class="card-image" (load)="cardImageLoaded=true">
            <h1 class="cardNumber" [ngStyle]="{'color':giftCards.imageTextColorCode}">
              <span>{{giftCards.cardNumber || giftCards.maskedCardNo}}</span>
              <button class="crd-cpy" *ngIf="cardType=='Virtual Card'" (click)="copyCardNumber()"><i class="icon-copy" [ngStyle]="{'color':giftCards.imageTextColorCode}"></i></button>
            </h1>
            <h2 class="expDate clearfix" [ngStyle]="{'color':giftCards.imageTextColorCode}" *ngIf="giftCards.expDate"><span class="vld-thr">VALID THRU</span> <div><div class="mh-ye">MONTH/YEAR</div><div class="mh-ye-txt">{{giftCards.expDate}}</div></div></h2>
            <h2 class="cardUserName" [ngStyle]="{'color':giftCards.imageTextColorCode}">{{giftCards.beneficiaryName}}</h2>
            <span class="cardDisplayName" [ngStyle]="{'color':giftCards.imageTextColorCode}">{{giftCards.cardDisplayName}}</span>
          </div>
        </div>
      </div>
      <div class="col-12 text-center" [ngClass]="{'pd-0' : cardType=='Physical Card'}">
        <div class="row card-info-row pl-2">
          <div class="col card-info" [ngClass]="{'col-6' : cardType=='Physical Card'}">
            <div>Balance</div>
            <div><span _ngcontent-mbq-c87="" class="card-currency">₹ </span>
              <span *ngIf="giftCards.currentBalance>=0">{{giftCards.currentBalance.toLocaleString('en-IN')}}</span>
            </div>
          </div>
          <div class="vl-line"></div>
          <div class="col card-info"  [ngClass]="{'phiscal-card-info' : cardType=='Physical Card'}">
            <div class="ml-10">Status</div>
            <div>{{giftCards.giftCardStatus}}</div>
          </div>
          <div class="vl-line" *ngIf="cardType=='Virtual Card'"></div>
          <div class="col card-info" *ngIf="cardType=='Virtual Card'">
            <div class="cvv-wrpr">
            <div>CVV</div>
              <div *ngIf="fetchingCvv">
              <span class="spinner-border small-loader" role="status">
                <span class="sr-only">Loading...</span>
              </span>
            </div>
            <div class="cvv-open" *ngIf="giftCards.cvv && !fetchingCvv"><span (click)="showHideCvvChange()">{{giftCards.cvv}}<i class="icon-hide"></i></span></div>
            <div class="cvv-start" *ngIf="!giftCards.cvv && !fetchingCvv"><span  (click)="showHideCvvChange()">{{'***'}}<i class="icon-view"></i></span></div>
          </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row m-0 mt-1" id="tran-sce-info" [style.height.px]="midSecHt">
      <div class="col-12 mt-0 txnSec-wrpr h-100">
        <div class="h-100">
          <div class=" txnSec-wrpr-content h-100">
            <h2 class="lts-txn-col">
              <span class="lts-txn-ttl">Latest Transactions</span>
              <span class="float-right text-more" (click)="getMoreTransactions()" *ngIf="initialTxnList && initialTxnList.length>1 && page==0">
                More
                <span class="fa fa-arrow-right ml-2"></span>
              </span>
            </h2>
            <div class="txnSec h-90"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()"
            [scrollWindow]="false">
            <div *ngFor="let item of transactions">
              <div class="txnSec-bdr d-flex" [ngClass]="{'active':item.displayDetail}">
                <div class="txnSec-inner w-95">
                  <div class="txnSec-img" [ngStyle]="{'background-color':gettxnIconColour(item)}">
                    <img [src]="getTxnTypeIcon(item)">
                  </div>
                  <div class="clearfix">
                    <div class="pull-left tran-ttl">{{item.category}}</div>
                    <div class="pull-right tran-ttl" [ngClass]="{'active':item.accountEntryType==='CREDIT'}">
                      <span *ngIf="item.accountEntryType==='DEBIT'">- </span> <span *ngIf="item.accountEntryType==='CREDIT'">+ </span>₹{{item.amount.toLocaleString('en-IN')}}</div>
                  </div>
                  <div class="clearfix">
                    <div class="pull-left tran-dt">{{item.serviceProvider}}</div>
                    <div class="pull-right tran-dt">{{getTxnTimeToDisplay(item.timeElapsed,item.txnDate)}}</div>
                  </div>
                </div>
                <div class="arrow-icon" (click)="getMoreTxnDetail(item)">
                  <span class="fa fa-angle-down" *ngIf="!item.displayDetail"></span>
                  <span class="fa fa-angle-up" *ngIf="item.displayDetail"></span>
                </div>
              </div>
              <div class="trx-dtls" *ngIf="item.displayDetail">
                <div class="trx-dt">{{moment(item.txnDate).format('DD MMMM YYYY')}}
                  <br>
                  <span>{{moment(item.txnDate).format('h:mm A')}}</span>
                </div>
                <div class="trx-dtl">{{item.narration}}</div>
              </div>
            </div>
            <div class="txnSec-spinner" *ngIf="gettingTxn">
              <div class="txnSec-inner pl-0">
                <span class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </span>
              </div>
            </div>
            <div class="txnSec-bdr" *ngIf="noMoreTxnText">
              <div class="txnSec-inner-notext">
                <span>{{noMoreTxnText}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer row m-0" id="bottomSec" *ngIf="bottomSecDisplay">
      <div class="foot-link col p-0" *ngIf="giftCards.giftCardStatus=='ACTIVE'">
        <div class="menu-title" (click)="editCard('lock')">Lock Card
          <span class="spinner-border loadingSplinner" *ngIf="isSaving && actionType=='lock'" role="status">
            <span class="sr-only"></span>
          </span>
        </div>
      </div>
      <div class="foot-link devideSec col p-0" *ngIf="(cardType=='Physical Card') && (giftCards.giftCardStatus=='ACTIVE' || giftCards.giftCardStatus=='EXPIRED')">
        <div class="menu-title" (click)="editCard('block')">Block Card
          <span class="spinner-border loadingSplinner" *ngIf="isSaving && actionType=='block'" role="status">
            <span class="sr-only"></span>
          </span>
        </div>
      </div>
      <div class="foot-link col p-0" *ngIf="giftCards.giftCardStatus=='LOCKED'">
        <div class="menu-title" (click)="editCard('unlock')">Unlock Card
          <span class="spinner-border loadingSplinner" *ngIf="isSaving && actionType=='unlock'" role="status">
            <span class="sr-only"></span>
          </span>
        </div>
      </div>
      <div class="foot-link devideSec col p-0" *ngIf="(cardType=='Physical Card') && giftCards.giftCardStatus=='BLOCKED'">
        <div class="menu-title" (click)="replaceCard('replace')">Replace Card
          <span class="spinner-border loadingSplinner" *ngIf="isReplacing" role="status">
            <span class="sr-only"></span>
          </span>
        </div>
      </div>
      <div class="foot-link devideSec col p-0" *ngIf="(cardType=='Physical Card') && giftCards.giftCardStatus=='ACTIVE'">
        <div class="menu-title" (click)="setPin()">Set PIN</div>
      </div>
    </div>
  </div>
</div>
<div class="alert-modal d-none" [ngClass]="{'d-block': isInactive && giftCards.currentBalance > 0}">
  <div class="backdrop"></div>
  <div class="alert-modal-content">
    <div class="alert-modal-head d-flex align-items-center justify-content-between">Activate Card<span (click)="toggleActivationModal()"></span></div>
    <div class="alert-modal-body">
      <div class="spinner-container" *ngIf="isLoading">
        <span class="spinner-border spinner-large loadingSplinner" role="status">
          <span class="sr-only"></span>
        </span>
      </div>
      <div *ngIf="!isLoading">
        Your card has been marked as ‘inactive’ as you have not done any transaction in last 1 year. Do you want to activate the card?
      </div>
    </div>
    <div class="alert-modal-footer d-flex align-items-center justify-content-between" [ngClass]="{'v-hidden':isLoading}">
      <div class="alert-modal-footer-btn alert-modal-footer-btn-cancel d-flex align-items-center justify-content-center" (click)="toggleActivationModal()">NO</div>
      <div class="alert-modal-footer-btn d-flex align-items-center justify-content-center" (click)="activateCard()">YES</div>
    </div>
  </div>
</div>
